var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "v-row",
        { attrs: { justify: "center" } },
        [
          _c(
            "v-col",
            { attrs: { cols: "12", lg: "11", xl: "10" } },
            [
              !_vm.isUserAdmin
                ? _c(
                    "v-alert",
                    {
                      staticClass: "mt-8",
                      attrs: { type: "error", outlined: "" },
                    },
                    [
                      _vm._v(
                        " You are not allowed to access SAPAPI diagnostics. "
                      ),
                    ]
                  )
                : _c(
                    "v-card",
                    {
                      staticClass: "mt-8 mb-8",
                      attrs: { loading: _vm.loading },
                    },
                    [
                      _c(
                        "template",
                        { slot: "progress" },
                        [
                          _c("v-progress-linear", {
                            attrs: {
                              color: "#006c27",
                              indeterminate: "",
                              height: "6",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-card-title",
                        { staticClass: "grey--text text--darken-2" },
                        [
                          _vm._v(" SAPAPI Portal Diagnostics "),
                          _c("v-spacer"),
                          _c("SAPAPIStatusOverride", {
                            attrs: { override: _vm.status.override },
                            on: {
                              changed: _vm.onOverrideChanged,
                              error: _vm.showError,
                            },
                          }),
                          _c(
                            "v-btn",
                            {
                              staticClass: "ml-2",
                              attrs: { text: "", color: "#006c27" },
                              on: { click: _vm.loadData },
                            },
                            [_vm._v("Reload")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-card-text",
                        [
                          _vm.status.override && _vm.status.override.status
                            ? _c(
                                "v-alert",
                                {
                                  attrs: {
                                    dense: "",
                                    outlined: "",
                                    type: "warning",
                                  },
                                },
                                [
                                  _vm._v(
                                    " A global " +
                                      _vm._s(_vm.status.override.status) +
                                      " override is active. Reason: " +
                                      _vm._s(_vm.status.override.reason) +
                                      " "
                                  ),
                                  _vm.status.override.updatedBy
                                    ? _c("span", [
                                        _vm._v(
                                          " Set by " +
                                            _vm._s(
                                              _vm.status.override.updatedBy
                                            ) +
                                            "."
                                        ),
                                      ])
                                    : _vm._e(),
                                ]
                              )
                            : _vm._e(),
                          _c(
                            "v-data-table",
                            {
                              staticClass: "elevation-1",
                              attrs: {
                                headers: _vm.headers,
                                items: _vm.portalRows,
                                "items-per-page": 6,
                                "hide-default-footer": "",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: `item.actualStatus`,
                                    fn: function ({ item }) {
                                      return [
                                        _c(
                                          "v-chip",
                                          {
                                            attrs: {
                                              "x-small": "",
                                              dark: "",
                                              color: _vm.statusColor(
                                                item.actualStatus
                                              ),
                                            },
                                          },
                                          [_vm._v(_vm._s(item.actualStatus))]
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: `item.status`,
                                    fn: function ({ item }) {
                                      return [
                                        _c(
                                          "v-chip",
                                          {
                                            attrs: {
                                              "x-small": "",
                                              dark: "",
                                              color: _vm.statusColor(
                                                item.status
                                              ),
                                            },
                                          },
                                          [_vm._v(_vm._s(item.status))]
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: `item.checkedAt`,
                                    fn: function ({ item }) {
                                      return [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.formatDate(
                                                item.lastProbe || item.checkedAt
                                              )
                                            ) +
                                            " "
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: `item.responseCode`,
                                    fn: function ({ item }) {
                                      return [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.valueOrDash(item.responseCode)
                                            ) +
                                            " "
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: `item.consecutiveSuccesses`,
                                    fn: function ({ item }) {
                                      return [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.valueOrDash(
                                                item.consecutiveSuccesses
                                              )
                                            ) +
                                            " "
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: `item.lastOutcome`,
                                    fn: function ({ item }) {
                                      return [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.formatOutcome(
                                                item.lastOutcome
                                              )
                                            ) +
                                            " "
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: `item.latency`,
                                    fn: function ({ item }) {
                                      return [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.latencySummary(item.latency)
                                            ) +
                                            " "
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: `item.failure`,
                                    fn: function ({ item }) {
                                      return [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              item.failure || item.reason || "-"
                                            ) +
                                            " "
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: `item.session`,
                                    fn: function ({ item }) {
                                      return [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.sessionSummary(item)) +
                                            " "
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            },
                            [
                              _c("template", { slot: "no-data" }, [
                                _vm._v("No portal status is available yet."),
                              ]),
                            ],
                            2
                          ),
                          _c("v-divider", { staticClass: "my-6" }),
                          _c(
                            "div",
                            {
                              staticClass: "d-flex flex-wrap align-center mb-3",
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "text-h6 grey--text text--darken-2 mr-4",
                                },
                                [_vm._v("Actual Portal Status History")]
                              ),
                              _c(
                                "v-btn-toggle",
                                {
                                  attrs: { mandatory: "", color: "#006c27" },
                                  model: {
                                    value: _vm.historyWindow,
                                    callback: function ($$v) {
                                      _vm.historyWindow = $$v
                                    },
                                    expression: "historyWindow",
                                  },
                                },
                                [
                                  _c(
                                    "v-btn",
                                    { attrs: { small: "", value: "15m" } },
                                    [_vm._v("15m")]
                                  ),
                                  _c(
                                    "v-btn",
                                    { attrs: { small: "", value: "1h" } },
                                    [_vm._v("1h")]
                                  ),
                                  _c(
                                    "v-btn",
                                    { attrs: { small: "", value: "6h" } },
                                    [_vm._v("6h")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "text-caption grey--text text--darken-1 mb-3",
                            },
                            [
                              _vm._v(
                                " Source: " +
                                  _vm._s(_vm.history.source || "-") +
                                  " "
                              ),
                              _c("span", { staticClass: "mx-1" }, [
                                _vm._v("|"),
                              ]),
                              _vm._v(
                                " Started: " +
                                  _vm._s(
                                    _vm.formatDate(_vm.history.startedAt)
                                  ) +
                                  " "
                              ),
                              _c("span", { staticClass: "mx-1" }, [
                                _vm._v("|"),
                              ]),
                              _vm._v(
                                " Retention: " +
                                  _vm._s(_vm.history.retention || "-") +
                                  " "
                              ),
                            ]
                          ),
                          !_vm.historyLoading &&
                          _vm.filteredHistory.length === 0
                            ? _c(
                                "v-alert",
                                {
                                  attrs: {
                                    dense: "",
                                    outlined: "",
                                    type: "info",
                                  },
                                },
                                [
                                  _vm._v(
                                    " No local status history is available for the selected period. History is retained only by the running CASS instance. "
                                  ),
                                ]
                              )
                            : _c("v-chart", {
                                staticClass: "history-chart",
                                attrs: {
                                  option: _vm.historyOption,
                                  autoresize: "",
                                },
                              }),
                          _vm.filteredHistory.length > 0
                            ? [
                                _c("v-divider", { staticClass: "my-6" }),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex flex-wrap align-center mb-3",
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "text-h6 grey--text text--darken-2 mr-4",
                                      },
                                      [_vm._v("Portal Latency")]
                                    ),
                                    _c(
                                      "v-btn-toggle",
                                      {
                                        attrs: {
                                          mandatory: "",
                                          color: "#006c27",
                                        },
                                        model: {
                                          value: _vm.latencyMetric,
                                          callback: function ($$v) {
                                            _vm.latencyMetric = $$v
                                          },
                                          expression: "latencyMetric",
                                        },
                                      },
                                      [
                                        _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              small: "",
                                              value: "latest",
                                            },
                                          },
                                          [_vm._v("Latest")]
                                        ),
                                        _c(
                                          "v-btn",
                                          {
                                            attrs: { small: "", value: "p50" },
                                          },
                                          [_vm._v("p50")]
                                        ),
                                        _c(
                                          "v-btn",
                                          {
                                            attrs: { small: "", value: "p95" },
                                          },
                                          [_vm._v("p95")]
                                        ),
                                        _c(
                                          "v-btn",
                                          {
                                            attrs: { small: "", value: "max" },
                                          },
                                          [_vm._v("Max")]
                                        ),
                                      ],
                                      1
                                    ),
                                    _c("v-spacer"),
                                    _c(
                                      "v-btn",
                                      {
                                        staticClass: "ml-4",
                                        attrs: {
                                          outlined: "",
                                          small: "",
                                          color: "#006c27",
                                          href: "https://monitor.dev.api.schaeffler/d/ad2wxhh/sap-apis-monitoring?from=now-24h&to=now&timezone=browser",
                                          target: "_blank",
                                          rel: "noopener noreferrer",
                                        },
                                      },
                                      [
                                        _vm._v(" Grafana "),
                                        _c(
                                          "v-icon",
                                          { attrs: { right: "", small: "" } },
                                          [_vm._v("mdi-open-in-new")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "text-caption grey--text text--darken-1 mb-3",
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.latencyMetricDescription) +
                                        " Failed probes contribute the timeout ceiling, so spikes show outages; the red reference line marks the 5 second threshold. Failed Latest samples are marked by outcome: red circle for timeout, orange diamond for transport error, and amber square for non-2xx. "
                                    ),
                                  ]
                                ),
                                _c("v-chart", {
                                  staticClass: "history-chart",
                                  attrs: {
                                    option: _vm.latencyOption,
                                    autoresize: "",
                                  },
                                }),
                              ]
                            : _vm._e(),
                          _c("v-divider", { staticClass: "my-6" }),
                          _c(
                            "div",
                            {
                              staticClass:
                                "text-h6 grey--text text--darken-2 mb-3",
                            },
                            [_vm._v("Recent Override Audit")]
                          ),
                          _c(
                            "v-data-table",
                            {
                              staticClass: "elevation-1",
                              attrs: {
                                headers: _vm.auditHeaders,
                                items: _vm.audits,
                                "items-per-page": 5,
                                "hide-default-footer": "",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: `item.status`,
                                    fn: function ({ item }) {
                                      return [
                                        _c(
                                          "v-chip",
                                          {
                                            attrs: {
                                              "x-small": "",
                                              outlined: "",
                                              color: item.status
                                                ? _vm.statusColor(item.status)
                                                : "#546e7a",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(item.status || "CLEAR") +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: `item.at`,
                                    fn: function ({ item }) {
                                      return [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.formatDate(item.at)) +
                                            " "
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: `item.actualStates`,
                                    fn: function ({ item }) {
                                      return [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.auditActualStates(item)
                                            ) +
                                            " "
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            },
                            [
                              _c("template", { slot: "no-data" }, [
                                _vm._v(
                                  "No override changes have been recorded."
                                ),
                              ]),
                            ],
                            2
                          ),
                        ],
                        2
                      ),
                    ],
                    2
                  ),
              _c(
                "v-snackbar",
                {
                  attrs: { color: _vm.snackbar.color, timeout: "4000" },
                  model: {
                    value: _vm.snackbar.visible,
                    callback: function ($$v) {
                      _vm.$set(_vm.snackbar, "visible", $$v)
                    },
                    expression: "snackbar.visible",
                  },
                },
                [_vm._v(" " + _vm._s(_vm.snackbar.text) + " ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }